export const getQrAddressContext = ({
  search = "",
  qrToken,
  qrBranchID,
  address,
  selectedBranchID,
}) => {
  const params = new URLSearchParams(search);

  return {
    parkingNumber:
      qrToken ||
      params.get("pn") ||
      params.get("tn") ||
      address?.token ||
      address?.parkingNumber,
    branchID:
      qrBranchID ||
      params.get("b") ||
      selectedBranchID ||
      address?.pickupArea,
  };
};
